module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kc-Ld.f826a724.png";